import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import {
  ProductListItemComponent,
  ProductListItemContext,
  ProductListItemContextSource,
} from '@spartacus/storefront';
import { UigMediaService } from 'src/app/services/uig-media.service';
import { UigShopViewService } from 'src/app/services/uig-shop-view.service';

@Component({
    selector: 'app-uig-product-list-item',
    templateUrl: './uig-product-list-item.component.html',
    styleUrls: ['./uig-product-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [
        ProductListItemContextSource,
        {
            provide: ProductListItemContext,
            useExisting: ProductListItemContextSource,
        },
    ],
    standalone: false
})
export class UigProductListItemComponent extends ProductListItemComponent {
  hasShopViewUserRole: boolean = true;
  constructor(
    productListItemContextSource: ProductListItemContextSource,
    private uigMediaService: UigMediaService,
    private uigShopViewService:UigShopViewService
  ) {
    super(productListItemContextSource);
    this.uigShopViewService.isShopViewMode().subscribe((hasRole) =>{
      this.hasShopViewUserRole = hasRole;
    })
  }

  resolveAbsoluteUrl(url: string) {
    return this.uigMediaService.resolveAbsoluteUrl(url);
  }
}
